<script setup lang="ts">
import { DaneCode } from '~/lib/models/lupap'
const emit = defineEmits(['set-city'])

const { daneCodes } = useLupap()

const setCity = (code: DaneCode) => {
  if (code) emit('set-city', code)
}
</script>

<template>
  <!-- Input autocomplete city -->
  <McAutocomplete
    name="city-autocomplete"
    :items="daneCodes"
    :max-items="5"
    key-value="city"
    @set="setCity"
  />
</template>
